import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51078aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-xl-6 align-items-center d-flex justify-content-center" }
const _hoisted_2 = { class: "video-container mt-xl-5 ml-xl-5 mb-5 mb-xl-0" }
const _hoisted_3 = { class: "loader" }
const _hoisted_4 = {
  key: 0,
  class: "fa-3x"
}

import '@fortawesome/fontawesome-svg-core/styles.css';
import { ref, onMounted, watch } from 'vue';
import { Streamer } from '@/helper/player';

const retryLimit = 5;

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayer',
  props: {
  dataStreamKey: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const streamPlayer = ref<HTMLVideoElement>();

const hasStarted = ref(false);
const isLoading = ref(false);
const fetchingVideo = ref(false);
const shouldRetry = ref(false);
let retryCount = 0;
let retryTimer: number | undefined = undefined;

const instanceRef = ref<Streamer>(null);

async function checkForStreaming() {
  const instance = new Streamer(streamPlayer.value, props.dataStreamKey);
  instanceRef.value = instance;
  console.log('instance', instance);
  if (shouldRetry.value) {
    shouldRetry.value = false;
  }

  if (retryCount >= retryLimit) {
    isLoading.value = false;
    retryCount = 0;
  } else {
    try {
      isLoading.value = true;
      const [hasAntMedia] = await Promise.allSettled([
        instance.checkAntMediaHasStream(),
      ]);

      if (hasAntMedia.status === 'fulfilled' && hasAntMedia.value) {
        isLoading.value = false;
        fetchingVideo.value = true;
        hasStarted.value = true;

        console.log('Should be running');

        return instance.playAntMediaStream(hasStarted);
      } else {
        if (retryCount >= retryLimit) {
          clearTimeout(retryTimer);
          isLoading.value = false;
          retryCount = 0;

          return false;
        }

        retryCount++;
        clearTimeout(retryTimer);
        retryTimer = setTimeout(checkForStreaming, 2000);

        return false;
      }
    } catch (error) {
      console.error('Error while checking for streaming:', error);
    }
  }
}

onMounted(() => {
  checkForStreaming();
});

watch(
  () => props.dataStreamKey,
  streamKey => {
    instanceRef.value?.switchStream(streamKey, hasStarted);
  },
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!hasStarted.value && (isLoading.value || fetchingVideo.value))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "circle-notch",
                    class: "fa-spin"
                  }))
                : _createCommentVNode("", true),
              (fetchingVideo.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 1,
                    icon: "spinner",
                    class: "fa-spin-pulse"
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!hasStarted.value && !isLoading.value && !fetchingVideo.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "fa-3x",
              style: {"background":"transparent","border":"none"},
              title: "Refresh",
              onClick: checkForStreaming
            }, [
              _createVNode(_component_font_awesome_icon, { icon: "rotate-right" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("video", {
        "data-stream-key": "63ff57667417f",
        id: "streamPlayer",
        ref_key: "streamPlayer",
        ref: streamPlayer,
        width: "100%",
        height: "auto",
        autoplay: "",
        playsinline: "",
        controls: "",
        muted: "",
        allow: "fullscreen",
        style: {"aspect-ratio":"16 / 9"}
      }, " Your browser does not support the video tag. ", 512)
    ])
  ]))
}
}

})